// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fast-game-play-page .game-img-wrap {
  width: 100%;
  max-width: var(--containerWidth);
  aspect-ratio: 85/48;
  margin: 0 auto;
  position: relative;
}
.fast-game-play-page .game-img-wrap .game-img-box {
  border: 6px solid var(--indigo-1000);
  border-radius: 0.75rem 0.75rem 0 0;
  box-shadow: 0px 4px 4px var(--black-250);
  display: flex;
  justify-content: center;
  align-items: center;
}
.fast-game-play-page .game-img-wrap .game-img-box img {
  width: 100%;
  height: 100%;
  border-radius: 0.375rem;
  object-fit: cover;
  object-position: center;
}
.fast-game-play-page .game-img-wrap .btn-box {
  background-color: var(--indigo-1000);
  border-radius: 0 0 0.75rem 0.75rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
}
.fast-game-play-page .game-img-wrap .btn-box .back-btn,
.fast-game-play-page .game-img-wrap .btn-box .fullscreen-btn {
  background-color: transparent;
  box-shadow: none;
  color: var(--white-1000);
  text-transform: capitalize;
}
.fast-game-play-page .game-img-wrap .btn-box .back-btn svg,
.fast-game-play-page .game-img-wrap .btn-box .fullscreen-btn svg {
  fill: var(--white-1000);
}
@media screen and (max-width: 474.98px) {
  .fast-game-play-page .game-img-wrap .btn-box .back-btn .text,
  .fast-game-play-page .game-img-wrap .btn-box .fullscreen-btn .text {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/FastGamePlay/FastGamePlayPageStyle.scss"],"names":[],"mappings":"AACE;EACE,WAAA;EACA,gCAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;AAAJ;AAEI;EACE,oCAAA;EACA,kCAAA;EACA,wCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAAN;AAEM;EACE,WAAA;EACA,YAAA;EACA,uBAAA;EACA,iBAAA;EACA,uBAAA;AAAR;AAII;EACE,oCAAA;EACA,kCAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;AAFN;AAIM;;EAEE,6BAAA;EACA,gBAAA;EACA,wBAAA;EACA,0BAAA;AAFR;AAIQ;;EACE,uBAAA;AADV;AAaE;EAKQ;;IACE,aAAA;EAdV;AACF","sourcesContent":[".fast-game-play-page {\n  .game-img-wrap {\n    width: 100%;\n    max-width: var(--containerWidth);\n    aspect-ratio: 85/48;\n    margin: 0 auto;\n    position: relative;\n\n    .game-img-box {\n      border: 6px solid var(--indigo-1000);\n      border-radius: 0.75rem 0.75rem 0 0;\n      box-shadow: 0px 4px 4px var(--black-250);\n      display: flex;\n      justify-content: center;\n      align-items: center;\n\n      img {\n        width: 100%;\n        height: 100%;\n        border-radius: 0.375rem;\n        object-fit: cover;\n        object-position: center;\n      }\n    }\n\n    .btn-box {\n      background-color: var(--indigo-1000);\n      border-radius: 0 0 0.75rem 0.75rem;\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      gap: 1rem;\n\n      .back-btn,\n      .fullscreen-btn {\n        background-color: transparent;\n        box-shadow: none;\n        color: var(--white-1000);\n        text-transform: capitalize;\n\n        svg {\n          fill: var(--white-1000);\n        }\n      }\n    }\n  }\n\n  @media screen and (max-width: 991.98px) {\n  }\n\n  @media screen and (max-width: 767.98px) {\n  }\n\n  @media screen and (max-width: 474.98px) {\n    .game-img-wrap {\n      .btn-box {\n        .back-btn,\n        .fullscreen-btn {\n          .text {\n            display: none;\n          }\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
